import { HttpErrorResponse, type HttpInterceptorFn } from '@angular/common/http';
import { TimeoutError, catchError, throwError, timeout } from 'rxjs';

// Auditoría de robustez 2026-07-06: la app no le ponía ningún límite de tiempo a los requests.
// Un backend colgado (no cae, no responde, no cierra la conexión) dejaba el botón "Guardar"/
// "Enviar" deshabilitado para siempre, sin ningún error ni forma de que el operador se entere —
// solo recargando la página se recuperaba. 30s cubre cómodo cualquier operación real de la app
// (ver docs/audit/FRONTEND-REPORT.md, p95 de submit/bcra/sb en metrics-technical).
const DEFAULT_TIMEOUT_MS = 30_000;

export const timeoutInterceptor: HttpInterceptorFn = (req, next) => {
  // Exportaciones y descarga de backups pueden tardar legítimamente más de 30s con datasets
  // grandes — no se les aplica límite de tiempo.
  if (req.responseType === 'blob') {
    return next(req);
  }

  return next(req).pipe(
    timeout(DEFAULT_TIMEOUT_MS),
    catchError((error: unknown) => {
      if (error instanceof TimeoutError) {
        // Se reformula como un HttpErrorResponse status 0: error.interceptor.ts ya lo trata como
        // fallo de red (mismo mensaje limpio "No se pudo conectar...", mismo flujo de reporte).
        return throwError(() => new HttpErrorResponse({ url: req.url, status: 0, statusText: 'Timeout' }));
      }
      return throwError(() => error);
    }),
  );
};
